"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./src/currency-mask.directive"));
__export(require("./src/currency-mask.module"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/~/ng2-currency-mask/index.js
// module id = ../../../../ng2-currency-mask/index.js
// module chunks = 4